<template>
  <div class="system">
    <p class="tip">温馨提示:<br/><span>请关注我行微服务进行扫码绑定</span></p>
  </div>
</template>

<script>
export default {
    data(){
        return{

        }
    },
    methods: {

    },
    created () {

    },
}
</script>

<style scoped>
.system{
  background-color: #fff;
  height: 100vh;
  padding-top: 30px;
  position: relative;
}
.tip{
  width: 90%;
  text-align: center;
  position: absolute;
  top: 50%;
  left:50%;
  font-size: 40px;
  color: #000;
  margin: 0;
  transform: translate(-50%,-50%);
}
.tip span{
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/system.vue